module.exports = __webpack_public_path__ + "img/LN_P-3.32a0c886.jpg";